// extracted by mini-css-extract-plugin
export var heroImage = "_md-1";
export var modal = "_md-0";